/* tslint:disable:typedef-whitespace align no-trailing-whitespace */


import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class HelpDocumentation
 *
 * @brief jump to the general documentation page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class HelpDocumentation extends Action {

  constructor(options: any = null) {

    super({
      key:   'help.help',
      type:  ActionType.Help_Help,
      label: 'Help',
      icon:  '<i class="far fa-question-circle"></i>',
      tip:   'View online documentation'
    });


  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[HelpDocumentation] executing...');







    return true;
  }
}
